import React from "react";

const RangeHighArrowIcon = ({ className, ...props }) => (
  <svg
    className={className}
    viewBox="0 0 8 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <path d="M7.29154 0.4375V3.9375C7.29154 4.179 7.09554 4.375 6.85404 4.375C6.61254 4.375 6.41654 4.179 6.41654 3.9375V1.49394L0.746555 7.16392C0.661388 7.24909 0.549371 7.29224 0.437371 7.29224C0.325371 7.29224 0.213354 7.24967 0.128188 7.16392C-0.0427292 6.993 -0.0427292 6.7159 0.128188 6.54498L5.79817 0.875H3.35404C3.11254 0.875 2.91654 0.679 2.91654 0.4375C2.91654 0.196 3.11254 0 3.35404 0H6.85404C6.9112 0 6.96785 0.0117282 7.02152 0.0338949C7.12827 0.0782282 7.21344 0.163398 7.25836 0.270732C7.27994 0.323815 7.29154 0.380333 7.29154 0.4375Z" />
  </svg>
);

export default RangeHighArrowIcon;
